import React from 'react';
import { Typography } from 'src/components/PulseUI';

const StringCell = ({ field, row }) => {
  return (
    <Typography variant="body2" className="pr-2">
      {row[field]}
    </Typography>
  );
};

export default StringCell;
